
































import Vue from 'vue';
import * as InputValidation from '@/mixins/inputValidation';

import DialogCard from '@/components/DialogCard.vue';

export default Vue.extend({
  components: {
    DialogCard
  },

  props: {
    initialName: String,
    // The duplicate dialog prefills these too.
    initialSection: {
      type: String,
      default: ''
    },
    initialDescription: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: 'Create a New Class'
    },
    createLabel: {
      type: String,
      default: 'Create'
    },
    createIcon: {
      type: String,
      default: 'mdi-plus'
    },
    // Shows a close icon by the title, for use in a dialog.
    closable: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      nameInput: this.initialName,
      sectionInput: this.initialSection,
      descriptionInput: this.initialDescription
    };
  },

  computed: {
    nameValidation(): InputValidation.InputLengthValidation {
      return InputValidation.validateInput(this.nameInput, 250, true);
    },

    sectionValidation(): InputValidation.InputLengthValidation {
      return InputValidation.validateInput(this.sectionInput, 250, false);
    },

    descriptionValidation(): InputValidation.InputLengthValidation {
      return InputValidation.validateInput(this.descriptionInput, 250, false);
    },

    createDisabled(): boolean {
      return (
        !this.nameValidation.valid ||
        !this.sectionValidation.valid ||
        !this.descriptionValidation.valid
      );
    }
  },

  methods: {
    onCreate() {
      this.$emit('create-group', {
        name: this.nameInput,
        section: this.sectionInput,
        description: this.descriptionInput
      });
    },

    onCancel() {
      this.$emit('cancel');
    }
  },

  watch: {
    initialName(val) {
      this.nameInput = val;
    },

    initialSection(val) {
      this.sectionInput = val;
    },

    initialDescription(val) {
      this.descriptionInput = val;
    }
  }
});
